/**
 * Agence'O - tablist
 * @author Guillaume Bouillon (Agence'O)
 * @created 14/05/2019
 */

(function ($) {

  if ($('.tablist__slider').length) {
    // slider
    const tabSlider = new Swiper('.tablist__slider', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      centerInsufficientSlides: true,
      touchEventsTarget: 'wrapper',
      wrapperClass: 'tablist__slider__wrapper',
      slideClass: 'tablist__slider__item',
      slideActiveClass: 'is-active',
      slideNextClass: 'is-next',
      breakpoints: {
        576: {
          spaceBetween: 10
        }
      }
    });

    $(document).on('click', '.tablist__tabs__link', (e) => {
      e.preventDefault();

      const targetId = $(e.currentTarget).attr('href');

      // tabs
      $('.tablist__tabs__link').removeClass('is-open').attr('aria-expanded', false);
      $(e.currentTarget).addClass('is-open').attr('aria-expanded', true);

      // contents
      $('.tablist__content').removeClass('is-open');
      $(targetId).addClass('is-open');

      // slider
      if (tabSlider) {
        $(tabSlider).each((i, slider) => {
          slider.update();
        });
      }

    });
  }

}(jQuery));
